import api from "../Utils/axios";
import { adminV1Base } from "../Utils/connection_strings";

export const getLandingContent = () => {
  return api.post(`${adminV1Base}/landing-content/get`, {});
};

export const upsertLandingContent = (content) => {
  return api.post(`${adminV1Base}/landing-content/upsert`, { content });
};

export const resetLandingContent = () => {
  return api.post(`${adminV1Base}/landing-content/reset`, {});
};

export const generateVideoThumbnail = (url) => {
  return api.post(`${adminV1Base}/landing-content/generate-thumbnail`, { url });
};
